// extracted by mini-css-extract-plugin
module.exports = {"empty":"style_empty__vVJNt"};